<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="reservedInstanceList"
      style="width: 100.1%;"
      :max-height="tableHeight"
      :loading="modalLoading"
    >
      <template slot-scope="{ row, index }" slot="operation">
        <Button
          type="info"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:reservedInstanceResource:elasticCache:config'
          ]"
          size="small"
          @click="configTag(row)"
          >配置标签</Button
        >
      </template>
    </Table>
    <!-- 配置标签页面 -->
    <configuration-reserved-instance-tag
      v-if="isShowReservedInstanceTag"
      ref="configurationReservedInstanceTag"
    ></configuration-reserved-instance-tag>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
import ConfigurationReservedInstanceTag from "../ConfigurationReservedInstanceTag";

var tableElastiCacheResourceVue = {};
export default {
  name: "TableElastiCacheResource",
  components: {
    ConfigurationReservedInstanceTag
  },
  data() {
    return {
      tableHeight: 0,
      isShowReservedInstanceTag: false,
      modalLoading: false,
      columns: [
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.accountID"),
          fixed: "left",
          minWidth: 120,
          key: "awsId"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.accountName"),
          minWidth: 150,
          key: "awsName"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: "tag",
          minWidth: 150,
          key: "tag"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.reservedCacheNodeID"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.productDescription"),
          minWidth: 150,
          key: "productDescription"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.CacheNodeType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.productType"),
          minWidth: 150,
          key: "offeringType"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.status"),
          minWidth: 150,
          key: "state"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.start"),
          minWidth: 150,
          key: "start",
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.overdue"),
          minWidth: 150,
          key: "end",
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.nodeAmount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.due"),
          minWidth: 150,
          key: "duration"
        },
        {
          title: this.$t("common.operation"),
          minWidth: 150,
          fixed: "right",
          slot: "operation"
        }
      ],
      reservedInstanceList: [],
      reservedInstanceListData: []
    };
  },
  beforeCreate: function() {
    tableElastiCacheResourceVue = this;
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 210;
    },
    // 显示数据
    getReservedInstances: function(reservedInstanceDTO) {
      tableElastiCacheResourceVue.reservedInstanceDTO = reservedInstanceDTO;
      // 转圈圈
      tableElastiCacheResourceVue.modalLoading = true;
      // 清空数据
      tableElastiCacheResourceVue.reservedInstanceList = [];
      tableElastiCacheResourceVue.$api.reservedInstance
        .getReservedCacheNodes(reservedInstanceDTO)
        .then(res => {
          tableElastiCacheResourceVue.modalLoading = false;
          if (res == null || res.data == null) {
            return;
          }
          let reservedInstances = res.data;
          for (let i = 0; i < reservedInstances.length; i++) {
            reservedInstances[i].start = utils.methods.formatDate(
              reservedInstances[i].start
            );
            reservedInstances[i].end = utils.methods.formatDate(
              reservedInstances[i].end
            );
            reservedInstances[i].duration =
              reservedInstances[i].duration === 31536000 ? "一年" : "三年";
          }
          tableElastiCacheResourceVue.reservedInstanceListData = JSON.parse(
            JSON.stringify(reservedInstances)
          );
          tableElastiCacheResourceVue.reservedInstanceList = reservedInstances;
        });
    },
    configTag: function(row) {
      this.isShowReservedInstanceTag = true;
      this.$nextTick(function() {
        this.$refs.configurationReservedInstanceTag.getConfigurationReservedInstanceTagList(
          row,
          2
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/elasticache/TableElasticacheResource.vue